import cx from 'clsx';

import type { ProductPriceProps } from '.';

export default function CouponDiscountedPrice({
  totalDiscountedPrice,
  price,
  className,
  is3x2 = false,
}: ProductPriceProps) {
  return (
    <div
      className={cx(['flex mt-4 flex-col disable-text-size-adjust', className])}
    >
      <div>
        <div className="text-[#3940DA] typo-footnote300-semibold">
          나의할인가
        </div>
        <p
          className="text-[#3940DA]"
          style={
            is3x2
              ? {
                  fontSize: 14,
                  fontWeight: 700,
                  lineHeight: '18px',
                }
              : { fontSize: '16px', fontWeight: '700', lineHeight: '20px' }
          }
        >
          {totalDiscountedPrice?.toLocaleString()}원
        </p>
      </div>
      <p className="mt-0 line-clamp-2 whitespace-pre-line text-description typo-footnote300-regular">
        {`${price.toLocaleString()}`}원{' '}
      </p>
    </div>
  );
}
